import React, { useState, useEffect } from 'react';
import "./Dashboard.css";
import bellIcon from '../../shared/assets/icons/bell.png';
import profileIcon from '../../shared/assets/icons/profile.png';
import profileHome from '../../shared/assets/icons/profileHome.png';
import dashboardIconOne from '../../shared/assets/icons/dashboardiconone.png';
import rightIcon from "../../shared/assets/icons/rightDashboard.png";
import requestIcon from "../../shared/assets/icons/request_web.png";
import logoIcon from "../../shared/assets/icons/logo-web.png";
import homeIcon from "../../shared/assets/icons/homess.png";
import equipment from "../../shared/assets/icons/equip_web.png";
import maintenance from '../../shared/assets/icons/maintenance.png';
import { dashboardService } from './services/dashboardService';
import DataTableGrid from '../../shared/components/DataTableGrid';
import {  STATUS_WORK_COMPLETED,STATUS_WORK_HOLD } from '../../shared/constants/statusConstants';
import { formatDateString } from '../../shared/utils/dateFormatter';

import { useNavigate } from 'react-router-dom';
const Dashboard = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  const [inProgressCount, setinProgressCount] = useState([])
  const [pendingCount, setPendingCount] = useState([])
  const [completeCount, setCompleteCount] = useState([])
  const [todayTasks, setTodaysTasks] = useState([])
  const [equipmentDatas, setEquipmentDatas] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);
  const tasksPerPage = 10;
  const itemsPerPage = 10;
  const getStatusLabel = (statusCode) => {
    switch (statusCode) {
      case 0:
        return 'UNASSIGNED';
      case 3:
        return 'REJECTED';
      case 10:
        return 'OPEN';
      case 12:
        return 'ASSIGNED';
      case 14:
        return 'WORK ON HOLD';
      case 16:
        return 'ACCEPTED';
      case 34:
        return 'COMPLETED';
      case -12:
        return 'UNASSIGNED';
      default:
        return 'WIP';
    }
  };
  
  const getPriorityLabel = (priorityCode) => {
    const priorityMap = { 0: 'Low',1: 'Medium',2: 'Normal', 3: 'High',4:'Urgent' };
    return priorityMap[priorityCode] || 'N/A';
  };
  const getContractTypeLabel = (contractCode) => {
    const contractMap = {
      0: 'PAID',
      1: 'UNDER WARRANTY',
      3: 'AMC'
    };
    return contractMap[contractCode] || 'N/A';
  };
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const data = await dashboardService.fetchMaintenanceRequests('-id');
        if (data.success) {
          // Change this line - use data.data instead of data.maintenance_requests
          const formattedTasks = data.data.map(item => ({
            id: item.id,
            wo_no: item.id,
            equipment: item.equipment_name,
            schedule_start: formatDateString(item.reported_time), // Changed from requested_date
            schedule_end: item.reported_time,   // Changed from requested_date
            status: getStatusLabel(item.status), // Convert status number to label
            priority: getPriorityLabel(item.priority), // Convert priority number to label
            technician: item.first_name  
              ? `${item.first_name} ${item.last_name}` 
              : 'N/A',
            description: item.notes || item.issues
          }));
          setTasks(formattedTasks);
  
          // Calculate status counts
          const inProgressCount = formattedTasks.filter(task => task.status === 'In Progress').length;
          setinProgressCount(inProgressCount);
          const pendingCount = formattedTasks.filter(task => task.status === 'Pending').length;
          setPendingCount(pendingCount);
          const completedCount = formattedTasks.filter(task => task.status === 'Completed').length;
          setCompleteCount(completedCount);
  
          // Filter today's tasks
          setTodaysTasks(formattedTasks);
          setTotalItems(formattedTasks.length); // Update if you have pagination info
        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
      }
    };
    fetchTasks();

    const fetchEquipmentDatas = async (page = 1) => {
      setLoading(true);
      try {
        const data = await dashboardService.fetchEquipment(page);
        // Change: data.equipments to data.data
        if (data.success && Array.isArray(data.data)) {
          const formattedData = data.data.map(item => ({
            serialNo: item.serial_number || item.serial_identifier, // Use actual field names
            name: item.serial_identifier, // Equipment name
            category: item.category,
            make: item.make,
            model: item.model,
            contractType: getContractTypeLabel(item.contract_type),
            address: item.address1 || 'N/A', // Use address1 from API
            fullAddress: `${item.address1 || ''}${item.address2 ? ', ' + item.address2 : ''}${item.city ? ', ' + item.city : ''}`.trim() || 'N/A',
            customerId: item.customer_id,
            companyName: item.company_name,
            equipmentId: item.equipment_id,
            itemId: item.item_id
          }));
          setEquipmentDatas(formattedData);
          setTotalItems(formattedData.length); // Update if you have pagination
          setAddresses(
            Array.from(new Set(formattedData.map(item => item.address).filter(addr => addr && addr !== 'N/A')))
          );
        }
      } catch (error) {
        console.error('Error fetching equipment:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEquipmentDatas();
  }, []);

  return (
    <div className="dashboard dashboard-background">
      <div className="dashboard-web">
        <header className="main-header">
          <h1 className="app-title"></h1>
          <div className="header-icons">
            <img src={bellIcon} alt="Notifications" className='notification-icon' />
            <img src={profileIcon} alt="Profile" className="icon profile-icon" onClick={() => navigate('/profile')} />
          </div>
        </header>

        <div className="inside-content">
          <h1 className="dashboard-title">Dashboard</h1>
          <div className="stats-container">
            <div className="stat-box stat-box-content" onClick={() => navigate('/tasklist?ongoing=true')}>
              <img src={dashboardIconOne} className="dashboard-icon" alt="Image 1" />
              <br />

              <br />
              <div className="stat-flex-container">
                <span className="stat-label">Ongoing</span>
                <img src={rightIcon}  className="right-arrow-icon" alt="Image 1" />
              </div>
            </div>
            <div className="stat-box stat-box-content" onClick={() => navigate(`/tasklist?status=${STATUS_WORK_HOLD}`)}>
              <img src={dashboardIconOne} className="dashboard-icon" alt="Image 1" />
              <br />

              <br />
              <div className="stat-flex-container">
                <span className="stat-label">Pending</span>
                <img src={rightIcon}  className="right-arrow-icon" alt="Image 1" />
              </div>
            </div>
            <div className="stat-box stat-box-content" onClick={() => navigate(`/tasklist?status=${STATUS_WORK_COMPLETED}`)}>
              <img src={dashboardIconOne} className="dashboard-icon" alt="Image 1" />
              <br />

              <br />
              <div className="stat-flex-container">
                <span className="stat-label">Completed</span>
                <img src={rightIcon}  className="right-arrow-icon" alt="Image 1" />
              </div>
            </div>
          </div>

          <div className="tables-container tables-flex-container">
            <div className="table-box">
              <div className="table-header">
                <h2>Today's Services</h2>
                <a href="#" className="view-all" onClick={() => navigate('/tasklist')}>
                  View All
                </a>
              </div>
              <DataTableGrid
                items={todayTasks.slice(0, 5)}
                loading={false}
                error={null}
                emptyMessage="No Request available"
                columns={[
                  { key: 'id', title: 'Req. ID', render: (task) => `${task.id}` },
                  { key: 'technician', title: 'Technician' },
                  { key: 'schedule_start', title: 'Reported On' },
                  { 
                    key: 'priority', 
                    title: 'Priority',
                  }
                ]}
              />
            </div>

            <div className="table-box">
              <div className="table-header">
                <h2>Equipments</h2>
                <a href="#" className="view-all" onClick={() => navigate('/equipmentlist')}>
                  View All
                </a>
              </div>
              <DataTableGrid
                items={equipmentDatas.slice(0, 5)}
                loading={loading}
                error={null}
                emptyMessage="No equipment data available"
                columns={[
                  { key: 'index', title: 'No.', render: (item, index) => index + 1 },
                  { key: 'name', title: 'Name', render: (equipment) => equipment.name || 'N/A' },
                  { key: 'serialNo', title: 'Serial No.', render: (equipment) => equipment.serialNo || 'N/A' },
                  { key: 'contractType', title: 'Contract Type', render: (equipment) => equipment.contractType || 'N/A' }
                ]}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-dashboard">
        <header className="mobile-header mobile-header-background">
          <div className="back-button">
            <img src={logoIcon} alt="Back" className="icon back-icon" />
          </div>
          <div className="main-mobile-header">
            <h2 className="main-title main-title-style">Home</h2>
          </div>

          <div className="header-icons">
            <img src={bellIcon} alt="Notifications" className="icon notification-icon-size" />
          </div>

        </header>

        <div className="quick-actions quick-actions-background">
          <div className="action-item">
            <div className="action-icon action-icon-style" onClick={() => navigate('/maintenance')}>
              <img src={requestIcon} alt="Back" className="icon back-icon" />
            </div>
            <span>Request</span>
          </div>
          <div className="action-item" >
            <div className="action-icon action-icon-style" onClick={() => navigate('/equipment')}>
              <img src={equipment} alt="Back" className="icon back-icon" />
            </div>
            <span>Equipment</span>
          </div>

        </div>

        <section className="tasks-section">
          <div className="tasks-header">
            <h2>Today's Task ({todayTasks.length})</h2>
            <a onClick={() => navigate('/tasklist')} className="view-all">View All</a>
          </div>
          <div className="task-list task-list-scroll">
            {todayTasks.slice(0, 5).map((task, idx) => (
              <div className="task-card" key={idx}>
                <div className="task-card-header">
                  <h3>{task.technician}</h3>
                  <span>#{task.id}</span>
                </div>
                <div className="task-card-info">
                  <p>Requested on</p>
                  <p>Status</p>
                </div>

                <div className="task-card-status">

                  <p className="task-date task-date-style">{task.schedule_start}</p>
                  <span className="task-status">{task.status}</span>

                </div>
              </div>
            ))}
          </div>
        </section>

        <footer className="mobile-footer mobile-footer-fixed">
          {[homeIcon, maintenance, profileHome].map((icon, idx) => (
            <button className={`footer-btn ${idx === 0 ? 'active' : ''}`} key={idx} onClick={() => {
              // if (idx === 2) {
              //   logoutUser();
              // } else {
              navigate(['/dashboard', '/tasklist', '/profile', '/menu'][idx]);
              // }
            }}>
              <img src={icon} alt="icon" className="icon footer-icon" />
            </button>
          ))}
        </footer>


      </div>
    </div>
  );
};

export default Dashboard;
